// Score -> segment + colour helpers shared across the NPS overview module.

export const SEGMENT = {
  PROMOTER: "promoter",
  PASSIVE: "passive",
  DETRACTOR: "detractor",
};

export const SEGMENT_LABEL = {
  [SEGMENT.PROMOTER]: "Promoter",
  [SEGMENT.PASSIVE]: "Passive",
  [SEGMENT.DETRACTOR]: "Detractor",
};

// Ant Design tag/status colour tokens, kept in sync with the design hand-off.
export const SEGMENT_COLOR = {
  [SEGMENT.PROMOTER]: { text: "#1E874B", bg: "#E9F6EE", bar: "#61C37C" },
  [SEGMENT.PASSIVE]: { text: "#9A6314", bg: "#FDF2E3", bar: "#E9A13B" },
  [SEGMENT.DETRACTOR]: { text: "#B3372C", bg: "#FCECEA", bar: "#E0483D" },
};

export const segmentFor = (score) =>
  score >= 9 ? SEGMENT.PROMOTER : score >= 7 ? SEGMENT.PASSIVE : SEGMENT.DETRACTOR;

export const colorForScore = (score) => SEGMENT_COLOR[segmentFor(score)].bar;

export const TREND_METRICS = {
  nps: { label: "NPS score", format: (v) => `${v}`, suffix: " pts" },
  promoters: { label: "Promoter %", format: (v) => `${v}%`, suffix: "%" },
  detractors: { label: "Detractor %", format: (v) => `${v}%`, suffix: "%" },
  avg: { label: "Average score", format: (v) => v.toFixed(1), suffix: " / 10" },
};

// Fallback used to fire the first dashboard request, before the API's own
// `filters.periods` list (which drives the dropdown) has loaded.
export const DEFAULT_PERIOD = "last_30_days";

// Periods come back as "last_30_days" / "last_45_days" etc - pull the day
// count out to compute concrete start_date/end_date for the API call.
export const daysFromPeriod = (period) => {
  const match = /\d+/.exec(period || "");
  return match ? Number(match[0]) : 30;
};
